import isIE from '@/utils/helpers/isIE';
import isEdge from '@/utils/helpers/isEdge';

export default () => !(isIE() || isEdge());
